import { Server, ShieldCheck, Cloud, GraduationCap, Rocket, Sparkles } from "lucide-react";

export type ServiceLink = {
  icon: typeof Server;
  name: string;
  href: string;
  description: string;
  features: string[];
  ctaText?: string;
  group?: "entry" | "onboarding" | "services";
};

// "Services" — M365 sub-brand offerings surfaced in the Header dropdown and Home page grid.
export const services: ServiceLink[] = [
  {
    icon: GraduationCap,
    name: "Customer Care",
    href: "/customer-care",
    description: "Free, do-it-yourself resources for any Microsoft 365 user. Plus: license through us and we'll match your current vendor's price — and beat it.",
    features: ["Free for any M365 user", "Price-match + beat on licensing", "Copilot how-tos & prompt library", "Free trainings & workshops"],
    group: "entry",
  },
  {
    icon: Sparkles,
    name: "M365 Copilot Success",
    href: "/m365-success",
    description: "The intelligent hub of Microsoft 365 — Copilot rollout, AI agents, Power Platform and prompt enablement, led by a dedicated M365 Superhero.",
    features: ["Copilot rollout & prompt enablement", "Custom Copilot Studio agents", "Power Platform automations", "Dedicated M365 Superhero"],
    group: "services",
  },
  {
    icon: Rocket,
    name: "M365 Core / Migration",
    href: "/migration",
    description: "Get onto Microsoft 365 the right way — professional email, Office apps and a clean, zero-data-loss migration.",
    features: ["Professional email setup", "Office apps + 1TB OneDrive", "Zero data loss migration", "Done in 1–3 days"],
    group: "onboarding",
  },
  {
    icon: Cloud,
    name: "M365 Cloud",
    href: "/cloud",
    description: "Work together from anywhere with SharePoint, Teams and a real business phone system.",
    features: ["SharePoint Online", "Microsoft Teams", "Teams Phone System", "Meeting recordings & transcripts"],
    group: "services",
  },
  {
    icon: ShieldCheck,
    name: "M365 Secure",
    href: "/secure",
    description: "Zero-Trust protection across identity, devices and data — self-monitored or fully managed.",
    features: ["MFA & Conditional Access", "Microsoft Defender suite", "Phishing simulation & training", "Compliance dashboards"],
    group: "services",
  },
  {
    icon: Server,
    name: "M365 Managed",
    href: "/managed",
    description: "Keep everything running smoothly with proactive monitoring, governance and license optimization.",
    features: ["24/7 health monitoring", "License optimization", "Governance & retention policies", "Direct expert access"],
    group: "services",
  },
];
